<template>
  <div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="服务项目列表" name="first">
            <Part1 ref="myPart1"></Part1>
          </el-tab-pane>
          <el-tab-pane label="服务项目图表" name="second">
            <Part2 ref="myPart2"></Part2>
          </el-tab-pane>
        </el-tabs>

  </div>
</template>

<script>

import Part1 from "./ElderlyOrderMonth";
import Part2 from "./ElderlyOrderMonthPie";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,

      activeName: '',
      userCode:'',

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    Part1,Part2
  },
  methods: {
    init(userCode){
      this.userCode = userCode;

      this.activeName = 'first';
      this.$refs.myPart1.init(this.userCode);

    },

    handleClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.name);

      if(tab.name == 'first'){
        this.$refs.myPart1.init(this.userCode);
      }
      if(tab.name == 'second'){
        this.$refs.myPart2.init(this.userCode);
      }

    },


  }
}


</script>

<style lang="scss" scoped>

</style>
